export const management = {
  routes: [
    {
      path: "/management/compliance-item",
      component: () => import("../management-library-compliance-item-view"),
    },
    {
      path: "/management/compliance-item-group",
      component: () => import("../management-library-compliance-item-group-view"),
    },
  ],
};
